import React from "react";
import { ScatterChart } from "react-chartkick";
import { toISODate } from "../helpers";

const StartedFinishedTimeChart = ({ poms }) => {
  const points = [];

  const days = {};
  let size = 0;

  poms.forEach(pom => {
    const date = toISODate(pom.stop);
    const stoppedAt = pom.stop.getHours() + pom.stop.getMinutes() / 60;
    const startedAt = pom.start.getHours() + pom.start.getMinutes() / 60;

    days[date] || (days[date] = size++);
    points.push([days[date], startedAt]);
  });

  return (
    <div>
      <ScatterChart
        data={points}
        xtitle="Date Index"
        ytitle="Time"
        curve={false}
        download={"stoptimesbyday"}
        title={"Pom Times by Day"}
        colors={["#e74c3c"]}
        max={24}
        min={8}
      />
      {/*<pre>{JSON.stringify(stopTimesByDay, null, 2)}</pre>*/}
    </div>
  );
};

export default StartedFinishedTimeChart;



// WEBPACK FOOTER //
// ./src/charts/TimesByDayChart.js